module.exports = __webpack_public_path__ + "static/slika-2-e6193ebae9e92f971beb5379fbc7ee85.png";